// extracted by mini-css-extract-plugin
export default {"select-sorter":"SelectSorter_select-sorter__8a6cw"};